<div class="card mb-4">
    <div class="card-header">
        <h4>Production Form</h4>
    </div>
    <div class="card-body">
        <form [formGroup]="productionForm" (ngSubmit)="onSubmit()">



            <div class="row">

                <div class="col form-group mb-3">
                    <label for="ticketNo">Ticket No</label>
                    <input type="text" id="ticketNo" formControlName="ticketNo" class="form-control" />
                </div>

                <div class="col form-group mb-3">
                    <label for="refNo">Ref No</label>
                    <input type="text" id="refNo" formControlName="refNo" class="form-control" />
                </div>

                <div class="col form-group mb-3">
                    <label for="poNumber">PO Number</label>
                    <input type="text" id="poNumber" formControlName="poNumber" class="form-control" />
                </div>

            </div>


            <div class="row">
                <div class="col form-group mb-3">
                    <label for="clientName">Client Name</label>
                    <input type="text" id="clientName" formControlName="clientName" class="form-control" />
                </div>

                <div class="col form-group mb-3">
                    <label for="jobName">Job Name</label>
                    <input type="text" id="jobName" formControlName="jobName" class="form-control" />
                </div>

                <div class="col form-group mb-3">
                    <label for="orderKgs">Order Kgs</label>
                    <input type="number" id="orderKgs" formControlName="orderKgs" class="form-control" />
                </div>
            </div>



            <!-- <div class="row">
                <div formArrayName="newOrderFields">
                  <div *ngFor="let field of productionForm.get('newOrderFields').value; let i = index" [formGroupName]="i" class="row">
                    <div class="col form-group mb-3">
                      <label for="process">New Order Process</label>
                      <input type="text" id="process" formControlName="process" class="form-control" />
                    </div>
                    
                    <div class="col form-group mb-3">
                      <label for="material">New Order Material</label>
                      <input type="text" id="material" formControlName="material" class="form-control" />
                    </div>
                    
                  </div>
                </div>
              </div>
               -->





            <!--Shift info-->
            <!-- <h5 class="text-center font-bold font-up danger-text">Shift Information</h5>
            <div class="row">
                <div class="col-3 col form-group mb-3">
                    <label class="form-label">Shift</label>
                    <select class="form-select" formControlName="shift" required>
                        <option value="" disabled selected>Select Shift</option>
                        <option value="A">A</option>
                        <option value="B">B</option>
                        <option value="C">C</option>
                        <option value="A 12">A 12</option>
                        <option value="B 12">B 12</option>
                    </select>
                </div>
                <div class="col-3 col form-group mb-3">
                    <label for="machine" class="form-label">Machine</label>
                    <select class="form-select" formControlName="machine" required>
                        <option value="" disabled selected>Select Machine</option>
                        <option value="P1-ROTO">P1-ROTO</option>
                        <option value="P2-ROTO">P2-ROTO</option>
                        <option value="P3-ROTO">P3-ROTO</option>
                        <option value="P4-ROTO">P4-ROTO</option>
                        <option value="P5-ROTO">P5-ROTO</option>
                        <option value="P6-ROTO">P6-ROTO</option>
                    </select>
                </div>
                <div class="col-3 col form-group mb-3">
                    <label for="operator" class="form-label">Operator</label>
                    <select class="form-select" formControlName="operator" id="operator" required>
                        <option value="" disabled selected>Select Operator</option>
                        <option value="Chandrakan" selected="">Chandrakan</option>
                        <option value="ASAMOAH">ASAMOAH</option>
                        <option value="BERTHA">BERTHA</option>
                        <option value="Brigh">Brigh</option>
                        <option value="Chandrakan">Chandrakan</option>
                        <option value="Daniel">Daniel</option>
                        <option value="Deepak">Deepak</option>
                        <option value="DEEPAK B">DEEPAK B</option>
                    </select>
                </div>
                <div class="col-3 col form-group mb-3">
                    <label for="operatingTime" class="form-label">Operating time</label>
                    <input type="text" formControlName="operatingTime" id="operatingTime" class="form-control" readonly
                        disabled />
                </div>
            </div>
            <div class="row">
                <div class="col form-group mb-3">
                    <label for="timeFrom" class="form-label">Time From</label>
                    <input type="time" formControlName="timeFrom" id="timeFrom" class="form-control" />

                    
                </div>
                <div class="col form-group mb-3">
                    <label for="timeTo" class="form-label">Time To</label>
                    <input type="time" formControlName="timeTo" id="timeTo" class="form-control" />
                  
                </div>
                <div class="col form-group mb-3">
                    <label for="mcSpeed" class="form-label">MC Speed (RPM)</label>
                    <input type="text" formControlName="mcSpeed" id="mcSpeed" class="form-control" />
                </div>
                <div class="col form-group mb-3">
                    <label for="inkGsm" class="form-label">Ink GSM</label>
                    <input type="text" formControlName="inkGsm" id="inkGsm" class="form-control" />
                </div>

            </div> -->


            <!-- process specific -->
            <div class="row">
                <div formArrayName="newOrderFields">

                    <div *ngFor="let field of newOrderFields.controls; let i = index" [formGroupName]="i" class="row">

                        <div class="col form-group mb-3 col-md-3 process-div">

                            <!-- <label for="process-{{ i }}">Order Process</label> -->
                            <label class="new prcs" for="process-{{ i }}">Processes</label>
                            <input type="text" id="process-{{ i }}" formControlName="process"
                                class="form-control process-fields" readonly />
                            <!-- <label class="process-check">
                        <input type="checkbox" (change)="onProcessCheckboxChange(i)" /> Enter Details
                      </label> -->
                        </div>

                        <!-- Material Section -->
    <div class="col form-group mb-3 col-md-3 process-div">
        <label class="new prcs" for="material-{{ i }}">Material</label>
        <input type="text" id="material-{{ i }}" formControlName="material" class="form-control process-fields" readonly />
      </div>
  
      <!-- MatReq Section -->
      <div class="col form-group mb-3 col-md-3 process-div">
        <label class="new prcs" for="matReq-{{ i }}">Mat Required</label>
        <input type="text" id="matReq-{{ i }}" formControlName="matReq" class="form-control process-fields" readonly />
      </div>


                        <!--               
                    <div class="col form-group mb-3">
                      Only show the material section if the material value is not null or empty
                      <label for="material-{{ i }}">New Order Material</label>
                      <input type="text" id="material-{{ i }}" formControlName="material" class="form-control" />
                    </div> -->


                    </div>
                </div>
            </div>











            <div class="row">
                <div formArrayName="combinedMaterials">
                    <div *ngFor="let material of productionForm.get('combinedMaterials').value; let i = index"
                        [formGroupName]="i" class="row">

                        <!-- Process Field Section -->
                        <div class="col form-group mb-3 col-md-3 process-div">
                            <label class="prcs" for="process-{{ i }}">Process</label>
                            <input type="text" id="process-{{ i }}" formControlName="process"
                                class="form-control process-fields" readonly />

                            <!-- Checkbox to toggle additional fields(Show Additional Fields) for this process -->
                            <!-- <label class="process-check">
                        <input type="checkbox" (change)="toggleFields(i)" /> Enter Details
                      </label> -->
                        </div>

                        <!-- Material Field Section -->
      <div class="col form-group mb-3 col-md-3  process-div">
        <label class="mat prcs" for="material-{{ i }}">Material</label>
        <input type="text" id="material-{{ i }}" formControlName="material"
               class="form-control process-fields" readonly />
      </div>

      <div class="col form-group mb-3 col-md-3 process-div">
        <label class="matRequired" for="matRequired-{{ i }}">Mat Required</label>
        <input type="text" id="matRequired-{{ i }}" formControlName="matRequired"
               class="form-control process-fields" readonly />
      </div>

                        <!-- Conditionally render additional fields based on checkbox -->


                    </div>
                </div>
            </div>


            <!-- process specific -->


            <!-- tabbing -->
            <ul class="nav nav-tabs">
                <li class="nav-item">
                    <a class="nav-link" [class.active]="tabActive === 'printing'"
                        (click)="onTabChange('printing')">Printing <span class="badge bg-success">{{ tabCompletion.printing }}%</span></a>

                        <!-- tab progress -->
                        <!-- <span class="badge bg-success">{{ tabCompletion.printing }}%</span> Always visible -->
                </li>
                <!-- Add other tabs as necessary -->
                <li class="nav-item">
                    <a class="nav-link" [class.active]="tabActive === 'lamination'"
                        (click)="onTabChange('lamination')">Lamination <span class="badge bg-success">{{ tabCompletion.lamination }}%</span> <!-- Always visible --></a>

                        
                </li>

                <li class="nav-item">
                    <a class="nav-link" [class.active]="tabActive === 'slitting'"
                        (click)="onTabChange('slitting')">Slitting <span class="badge bg-success">{{ tabCompletion.slitting }}%</span> <!-- Always visible --></a>

                       
                </li>

                <li class="nav-item">
                    <a class="nav-link" [class.active]="tabActive === 'cutting'"
                        (click)="onTabChange('cutting')">Cutting <span class="badge bg-success">{{ tabCompletion.cutting }}%</span> <!-- Always visible --></a>
                         <!-- when active -->
                        <!-- <span *ngIf="tabActive === 'cutting'" class="badge bg-success">{{ tabCompletion.cutting }}%</span> -->
                         <!-- bydefault inactive -->
                         <!-- <span class="badge bg-success">{{ tabCompletion.cutting }}%</span> Always visible -->
                </li>
            </ul>


            <div *ngIf="tabActive === 'printing'">
                <!-- Process Checkboxes (Extrusion, addProduction, Inking) -->
                <div class="form-group mb-3 process mt-3">
                    <!-- <label class="process-label">Select Processes</label> -->
                    <!-- <div class="form-check">
                    <input type="checkbox" class="form-check-input" id="extrusion" formControlName="extrusion"
                        (change)="onProcessChange('extrusion')">
                    <label class="form-check-label" for="extrusion">Extrusion</label>
                </div> -->
                    <div class="form-check">
                        <input type="checkbox" class="form-check-input" id="addProduction"
                            formControlName="addProduction" (change)="onProcessChange('addProduction')">
                        <label class="form-check-label" for="addProduction">Add Rolls</label>
                    </div>
                    <div class="form-check">
                        <input type="checkbox" class="form-check-input" id="inking" formControlName="inking"
                            (change)="onProcessChange('inking')">
                        <!-- <input type="checkbox" class="form-check-input"  [routerLink]="['/addInk']"> -->
                        <label class="form-check-label" for="inking">Add Ink</label>
                    </div>
                </div>

                <!-- Conditionally Render Extrusion Fields -->
                <!-- <div *ngIf="productionForm.get('extrusion').value">
                <div class="row mb-3">
                    <div class="col-md-3">
                        <div class="form-group">
                            <label for="extrusionJobName">Job Name</label>
                            <input type="text" id="extrusionJobName" formControlName="extrusionJobName"
                                class="form-control" />
                        </div>
                    </div>
                    <div class="col-md-3">
                        <div class="form-group">
                            <label for="extrusionClientName">Client Name</label>
                            <input type="text" id="extrusionClientName" formControlName="extrusionClientName"
                                class="form-control" />
                        </div>
                    </div>
                    <div class="col-md-3">
                        <div class="form-group">
                            <label for="extrusionOrderKgs">Order Kgs</label>
                            <input type="number" id="extrusionOrderKgs" formControlName="extrusionOrderKgs"
                                class="form-control" />
                        </div>
                    </div>
                </div>
            </div> -->

                <!-- Conditionally Render Add Production Fields -->
                <div *ngIf="productionForm.get('addProduction').value">




                    <!--Shift info-->
                    <h5 class="text-center font-bold font-up danger-text">Shift Information</h5>
                    <div class="row">
                        <div class="col-3 col form-group mb-3">
                            <label class="form-label">Shift</label>
                            <select class="form-select" formControlName="shift" required>
                                <option value="" disabled selected>Select Shift</option>
                                <option value="A">A</option>
                                <option value="B">B</option>
                                <option value="C">C</option>
                                <option value="A 12">A 12</option>
                                <option value="B 12">B 12</option>
                            </select>
                        </div>
                        <div class="col-3 col form-group mb-3">
                            <label for="machine" class="form-label">Machine</label>
                            <select class="form-select" formControlName="machine" required>
                                <option value="" disabled selected>Select Machine</option>
                                <option value="P1-ROTO">P1-ROTO</option>
                                <option value="P2-ROTO">P2-ROTO</option>
                                <option value="P3-ROTO">P3-ROTO</option>
                                <option value="P4-ROTO">P4-ROTO</option>
                                <option value="P5-ROTO">P5-ROTO</option>
                                <option value="P6-ROTO">P6-ROTO</option>
                            </select>
                        </div>
                        <div class="col-3 col form-group mb-3">
                            <label for="operator" class="form-label">Operator</label>
                            <select class="form-select" formControlName="operator" id="operator" >
                                <option value="" disabled selected>Select Operator</option>
                                <option value="Chandrakan" selected="">Chandrakan</option>
                                <option value="ASAMOAH">ASAMOAH</option>
                                <option value="BERTHA">BERTHA</option>
                                <option value="Brigh">Brigh</option>
                                <option value="Chandrakan">Chandrakan</option>
                                <option value="Daniel">Daniel</option>
                                <option value="Deepak">Deepak</option>
                                <option value="DEEPAK B">DEEPAK B</option>
                            </select>
                        </div>
                        <div class="col-3 col form-group mb-3">
                            <label for="operatingTime" class="form-label">Operating time</label>
                            <input type="text" formControlName="operatingTime" id="operatingTime" class="form-control"
                                readonly disabled />
                        </div>
                    </div>
                    <div class="row">
                        <div class="col form-group mb-3">
                            <label for="timeFrom" class="form-label">Time From</label>
                            <input type="time" formControlName="timeFrom" id="timeFrom" class="form-control" />

                            <!-- for hour interval -->
                            <!-- <select formControlName="timeFrom" id="timeFrom" class="form-control">
                        <option *ngFor="let time of hourIntervals" [value]="time">{{ time }}</option>
                      </select> -->
                        </div>
                        <div class="col form-group mb-3">
                            <label for="timeTo" class="form-label">Time To</label>
                            <input type="time" formControlName="timeTo" id="timeTo" class="form-control" />
                            <!-- <select formControlName="timeTo" id="timeTo" class="form-control">
                        <option *ngFor="let time of hourIntervals" [value]="time">{{ time }}</option>
                      </select> -->
                        </div>
                        <div class="col form-group mb-3">
                            <label for="mcSpeed" class="form-label">MC Speed (RPM)</label>
                            <input type="text" formControlName="mcSpeed" id="mcSpeed" class="form-control" />
                        </div>
                        <div class="col form-group mb-3">
                            <label for="inkGsm" class="form-label">Ink GSM</label>
                            <input type="text" formControlName="inkGsm" id="inkGsm" class="form-control" />
                        </div>

                    </div>






                    <h5 class="text-left font-bold font-up danger-text">Printing Production Info</h5>
                    <div class="row mb-3">
                        <div class="col-md-6">
                            <div class="form-group">
                                <label class="form-label">Material</label>
                                <!-- <input type="text" id="materialCategory" formControlName="materialCategory"
                                class="form-control" /> -->

                                <select id="materialCategory" formControlName="materialCategory" class="form-select">
                                    <option value="CLEAR BOPP ">CLEAR BOPP </option>
                                    <option value="MET BOPP">MET BOPP</option>
                                    <option value="ADDITIVES">ADDITIVES</option>
                                    <option value="C BOPP">C BOPP</option>
                                    <option value="CLEAR CPP">CLEAR CPP</option>
                                    <option value="PEARLIZED BOPP">PEARLIZED BOPP</option>
                                    <option value="PET">PET</option>
                                    <option value="PET G">PET G</option>
                                </select>
                            </div>
                        </div>
                    </div>

                    <div class="row mb-3">
                        <div class="col-md-4">
                            <div class="form-group">
                                <label for="matSpecifications">Material Specifications</label>
                                <!-- <input type="text" id="matSpecifications" formControlName="matSpecifications"
                                class="form-control" /> -->

                                <select id="matSpecifications" formControlName="matSpecifications" class="form-control">
                                    <option *ngFor="let specification of matSpecifications" [value]="specification">
                                        {{specification}}</option>
                                </select>
                            </div>
                        </div>
                        <div class="col-md-2">
                            <div class="form-group">
                                <!-- Mat Roll No -->
                                <label for="matRollNo">Input Roll No</label>
                                <!-- <input type="text" id="matRollNo" formControlName="matRollNo" class="form-control" /> -->

                                <!-- use this if want all matRollNo -->
                                <!-- <select id="matRollNo" formControlName="matRollNo" class="form-select" required>
                                <option value="" disabled>Select Mat Roll No</option>
                                <option *ngFor="let roll of inventoryList" [value]="roll.rollNo">{{ roll.rollNo }}</option>
                              </select> -->
                                    
                              <!-- before removal -->
                                <!-- <select id="matRollNo" formControlName="matRollNo" class="form-select">
                                    <option value="" disabled selected>Select Mat Roll No</option>
                                    <option *ngFor="let roll of filteredInventoryList" [value]="roll.rollNo">{{
                                        roll.rollNo }}</option>
                                </select> -->

                                 <!-- after removal -->
                                <select formControlName="matRollNo" class="form-select">
                                    <option value="" disabled selected>Select Mat Roll No</option>
                                    <option *ngFor="let roll of filteredInventoryList" 
                                            [value]="roll.rollNo" 
                                            [disabled]="usedMatRollNos.has(roll.rollNo)">
                                      {{ roll.rollNo }}
                                    </option>
                                  </select>
                            </div>
                        </div>
                        <div class="col-md-2">
                            <div class="form-group">
                                <label for="prodWeight">Weight Kgs</label>
                                <input type="text" id="prodWeight" formControlName="prodWeight" class="form-control" />
                            </div>
                        </div>

                        <div class="col-md-2">
                            <div class="form-group">
                                <label for="prodReturn">Return Kgs</label>
                                <input type="text" id="prodReturn" formControlName="prodReturn" class="form-control" />
                            </div>
                        </div>

                        <!-- available time -->
                        <!-- <div class="col-md-2">
                        <div class="form-group">
                            <label for="availTime">Available Time</label>
                            <input type="text" id="availTime" formControlName="availTime" class="form-control" />
                        </div>
                    </div> -->
                        <div class="col-md-2 hidden">
                            <div class="form-group">
                                <label for="availTime">Available Time</label>
                                <input type="text" formControlName="availTime" id="availTime" class="form-control"
                                    readonly />
                            </div>
                        </div>
                    </div>

                    <div class="row mb-3">
                        <div class="col-md-3">
                            <div class="form-group">
                                <label for="prodOutputRollNo">Output Roll No</label>
                                <input type="text" id="prodOutputRollNo" formControlName="prodOutputRollNo"
                                    class="form-control" />
                            </div>
                        </div>
                        <div class="col-md-3">
                            <div class="form-group">
                                <label for="prodOutputKg">Output Kgs</label>
                                <input type="text" id="prodOutputKg" formControlName="prodOutputKg"
                                    class="form-control" />
                            </div>
                        </div>
                        <div class="col-md-3">
                            <div class="form-group">
                                <label for="prodWaste">Waste Kgs</label>
                                <input type="text" id="prodWaste" formControlName="prodWaste" class="form-control" />
                            </div>
                        </div>

                        <div class="col-md-3">
                            <div class="form-group">
                                <label for="prodFlag">Flag</label>
                                <input type="text" id="prodFlag" formControlName="prodFlag" class="form-control" />
                            </div>
                        </div>
                    </div>


                    <!-- table -->
                     <!-- table  -->
                <!-- <button type="button" class="btn btn-success offset-md-10" (click)="saveProductionData()">Save</button> -->
                <button 
                type="button" 
                class="btn btn-success " 
                (click)="saveProductionData()"
                [disabled]="!isSaveEnabled">
                Save Production Details
              </button>

                <!-- Table to show saved data -->
                <!-- <div *ngIf="savedProductionData.length > 0" class="mt-3">
                    <h6>Saved Production Data</h6>
                    <table class="table table-striped">
                        <thead>
                            <tr>
                                <th>Input Roll Id</th>
                                <th>Material Specification</th>
                                <th>Weight (Kgs)</th>
                                <th>Return (Kgs)</th>

                                <th>Output Roll Id</th>
                                <th>Output (Kgs)</th>
                                <th>Output Wastage</th>
                                <th>Flag</th>
                                
                            </tr>
                        </thead>
                        <tbody>
                            <tr *ngFor="let data of savedProductionData">
                                <td>{{ data.matRollNo }}</td>
                                <td>{{ data.matSpecifications }}</td>
                                <td>{{ data.prodWeight }}</td>
                                <td>{{ data.prodReturn }}</td>

                                <td>{{ data.prodOutputRollNo }}</td>
                                <td>{{ data.prodOutputKg }}</td>
                                <td>{{ data.prodWaste }}</td>
                                <td>{{ data.prodFlag }}</td>
                               
                            </tr>
                        </tbody>
                    </table>
                </div> -->


                </div>

                <!-- Conditionally Render Inking Fields -->
                <div *ngIf="productionForm.get('inking').value">

                    <h5 class="text-left font-bold font-up danger-text mt-5">Add Ink Details</h5>
                    <div class="row mb-3">
                        <div class="col-md-3">
                            <div class="form-group">
                                <label for="inkName">Ink Name</label>
                                <!-- <input type="text" id="inkName" formControlName="inkName" class="form-control" /> -->
                                <select class="form-select" formControlName="inkName" >
                                    <option value="" disabled selected>Select Ink Name</option>
                                    <option value="INK PEONY">INK PEONY</option>
                                    <option value="INK ALPINE">INK ALPINE</option>
                                    <option value="VIOLET">VIOLET</option>
                                    <option value="MAGENTA">MAGENTA</option>
                                    <option value="INK BOPP">INK BOPP</option>
                                    <option value="INK POLY">INK POLY</option>
                                </select>
                            </div>
                        </div>
                        <div class="col-md-3">
                            <div class="form-group">
                                <label for="inkColor">Ink Color</label>
                                <!-- <input type="number" id="inkColor" formControlName="inkColor" class="form-control" /> -->
                                <select class="form-select" formControlName="inkColor" >
                                    <option value="" disabled selected>Select Ink Color</option>
                                    <option value="CYAN">CYAN</option>
                                    <option value="RED">RED</option>
                                    <option value="BLACK">BLACK</option>
                                    <option value="BLUE">BLUE</option>
                                    <option value="GREEN">GREEN</option>
                                    <option value="GOLD">GOLD</option>
                                    <option value="MAGETA">MAGETA</option>
                                    <option value="ORANGE">ORANGE</option>
                                    <option value="MEDIUM">MEDIUM</option>
                                    <option value="REFLEX">REFLEX</option>
                                    <option value="VIOLET">VIOLET</option>
                                    <option value="WHITE">WHITE</option>
                                    <option value="VANISH">VANISH</option>
                                    <option value="BROWN">BROWN</option>
                                    <option value="YELLOW">YELLOW</option>
                                    <option value="OPV">OPV</option>
                                    <option value="HARDNER">HARDNER</option>
                                </select>
                            </div>
                        </div>
                        <div class="col-md-3">
                            <div class="form-group">
                                <label for="inkType">Ink Type</label>
                                <!-- <input type="text" id="inkType" formControlName="inkType" class="form-control" /> -->
                                <!-- <select class="form-select" formControlName="inkType" required> -->
                                    <select class="form-select" formControlName="inkType">
                                    <option value="" disabled selected>Select Ink Type</option>
                                    <option value="Mixed">Mixed</option>
                                    <option value="Fresh">Fresh</option>

                                </select>
                            </div>
                        </div>
                        <div class="col-md-3">
                            <div class="form-group">
                                <label for="issue">Issue</label>
                                <input type="text" id="issue" formControlName="issue" class="form-control" />
                            </div>
                        </div>
                        <div class="col-md-3">
                            <div class="form-group">
                                <label for="inkReturn">Return(Kgs)</label>
                                <input type="text" id="inkReturn" formControlName="inkReturn" class="form-control" />
                            </div>
                        </div>
                        <!-- <div class="col-md-3">
                        <div class="form-group">
                            <label for="breakdown">Breakdown</label>
                            <input type="text" id="breakdown" formControlName="breakdown" class="form-control" />
                        </div>
                    </div> -->


                        <!-- Breakdown -->
                        <div class="form-group mb-3 breakdown-button">

                            <div class="form-check">
                                <input type="checkbox" class="form-check-input" id="breakdown"
                                    formControlName="breakdown" (change)="onProcessChangeBreakdown('breakdown')">
                                <label class="form-check-label" for="breakdown">Capture Breakdown</label>
                            </div>
                        </div>

                        <!-- Conditionally Render breakdown Fields -->
                        <div *ngIf="productionForm.get('breakdown').value">
                            <div class="row mb-3">
                                <div class="col-3 col form-group mb-3">
                                    <!-- <div class="form-group"> -->
                                    <!-- <label for="extrusionJobName">DownTime</label>
              <input type="text" id="extrusionJobName" formControlName="extrusionJobName" class="form-control" /> -->
                                    <label class="">DownTime</label>
                                    <select class="form-select" formControlName="downTime" id="downTime" >
                                        <option value="" disabled selected>Select DownTime</option>
                                        <option value="Breakdown">Breakdown</option>
                                        <option value="JCO">JCO</option>
                                        <option value="Cylinder Clean">Cylinder Clean</option>
                                        <option value="D/B Change">D/B Change</option>
                                        <option value="Splice Fail">Splice Fail</option>
                                        <option value="Power Fail">Power Fail</option>
                                        <option value="AW Approval">AW Approval</option>
                                        <option value="Shade Approval">Shade Approval</option>
                                        <option value="No Operator">No Operator</option>
                                        <option value="Maintenance">Maintenance</option>
                                        <option value="Material Shortage">Material Shortage</option>
                                    </select>
                                    <!-- </div> -->
                                </div>
                                <div class="col-md-3">
                                    <div class="form-group">
                                        <label for="downTimeTime">Time (Minutes)</label>
                                        <!-- <input type="text" id="downTimeTime" formControlName="downTimeTime"
                                        class="form-control" /> -->
                                        <select formControlName="downTimeTime" class="form-control">
                                            <option *ngFor="let time of timeIntervals" [value]="time">{{ time }}
                                            </option>
                                        </select>
                                    </div>
                                </div>
                                <div class="col-md-3">
                                    <div class="form-group">
                                        <label for="downTimeRemarks">DownTime Remarks</label>
                                        <input type="text" id="downTimeRemarks" formControlName="downTimeRemarks"
                                            class="form-control" />
                                    </div>
                                </div>
                            </div>

                            <button type="button" class="btn btn-primary" (click)="captureDownTime()">Capture DownTime</button>
                        </div>

                       

                    </div>

                    <!-- Save Ink Details Button -->
                    <button type="button" class="btn btn-success " (click)="saveInkData()">Save Ink
                        Details</button>
                        <!-- <button 
  type="button" 
  class="btn btn-success offset-md-10" 
  (click)="saveInkData()"
  [disabled]="!isInkSaveEnabled">
  Save Ink Details
</button> -->

                    <!-- Table to show saved ink data -->
                    <div *ngIf="savedInkData.length > 0" class="mt-3">
                        <h6>Saved Ink Data</h6>
                        <table class="table table-striped">
                            <thead>
                                <tr>
                                    <th>Ink Name</th>
                                    <th>Ink Color</th>
                                    <th>Ink Type</th>
                                    <th>Issue</th>
                                    <th>Return (Kgs)</th>
                                     <th>Action</th> <!-- Added Action column for delete -->
                                </tr>
                            </thead>
                            <tbody>
                                <tr *ngFor="let data of savedInkData; let i = index">
                                    <td>{{ data.inkName }}</td>
                                    <td>{{ data.inkColor }}</td>
                                    <td>{{ data.inkType }}</td>
                                    <td>{{ data.issue }}</td>
                                    <td>{{ data.inkReturn }}</td>
                                        <td> <!-- Action column with delete button -->
          <button type="button" class="btn btn-danger btn-sm" (click)="deleteInkData(i)">Delete</button>
        </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>

                 <!-- table for production data -->
                <div *ngIf="savedProductionData.length > 0" class="mt-3">
                    <h6>Saved Production Data</h6>
                    <table class="table table-striped">
                        <thead>
                            <tr>
                                <th>Input Roll Id</th>
                                <th>Input Material</th>
                                <th>Weight (Kgs)</th>
                                <th>Return (Kgs)</th>

                                <th>Output Roll Id</th>
                                <th>Output (Kgs)</th>
                                <th>Output Wastage</th>
                                <th>Flag</th>
                                <th>Action</th> <!-- New column for delete action -->
                                
                            </tr>
                        </thead>
                        <tbody>
                            <!-- ; let i = index for deletion -->
                            <tr *ngFor="let data of savedProductionData; let i = index">
                                <td>{{ data.matRollNo }}</td>
                                <td>{{ data.matSpecifications }}</td>
                                <td>{{ data.prodWeight }}</td>
                                <td>{{ data.prodReturn }}</td>

                                <td>{{ data.prodOutputRollNo }}</td>
                                <td>{{ data.prodOutputKg }}</td>
                                <td>{{ data.prodWaste }}</td>
                                <td>{{ data.prodFlag }}</td>
                                <td> <!-- Action column with delete button -->
                                    <button type="button" class="btn btn-danger btn-sm" (click)="deleteProductionData(i)">Delete</button>
                                  </td>
                               
                            </tr>
                        </tbody>

                        <tfoot>
                            <tr>
                              <th colspan="2">Total</th>
                              <th>{{ totalProdWeight }}</th>
                              <th>{{ totalProdReturn }}</th>
                          
                              <th></th>
                              <th>{{ totalOutputKg }}</th>
                              <th>{{ totalProdWaste }}</th>
                              <th>{{ totalProdFlag }}</th>
                              <th></th>
                            </tr>
                          </tfoot>
                    </table>
                </div>

                <!-- Display Saved DownTime Data -->
<div *ngIf="savedDownTimeData.length > 0" class="mt-3">
    <h6>Saved DownTime Data</h6>
    <table class="table table-striped">
        <thead>
            <tr>
                <th>DownTime Type</th>
                <th>Time (Minutes)</th>
                <th>Remarks</th>
            </tr>
        </thead>
        <tbody>
            <tr *ngFor="let data of savedDownTimeData">
                <td>{{ data.downTime }}</td>
                <td>{{ data.downTimeTime }}</td>
                <td>{{ data.downTimeRemarks }}</td>
            </tr>
        </tbody>
    </table>
</div>

            </div>




            <!-- lamination -->
            <div *ngIf="tabActive === 'lamination'">
                <h5 class="text-left font-bold font-up danger-text">Lamination Details</h5>
                <div class="row mb-3">
                    <div class="col-md-4">
                        <div class="form-group">
                            <label for="laminationMachine">Lamination Machine</label>
                            <!-- <select class="form-select" formControlName="laminationMachine" required> -->
                                <select class="form-select" formControlName="laminationMachine" >
                                <option value="" disabled selected>Select Lamination Machine</option>
                                <option value="Machine 1">Machine 1</option>
                                <option value="Machine 2">Machine 2</option>
                                <option value="Machine 3">Machine 3</option>
                            </select>
                        </div>
                    </div>
                    <div class="col-md-4">
                        <div class="form-group">
                            <label for="laminationFilm">Lamination Film</label>
                            <select class="form-select" formControlName="laminationFilm" >
                                <option value="" disabled selected>Select Lamination Film</option>
                                <option value="Film A">Film A</option>
                                <option value="Film B">Film B</option>
                                <option value="Film C">Film C</option>
                            </select>
                        </div>
                    </div>
                    <div class="col-md-4">
                        <div class="form-group">
                            <label for="laminationOperator">Lamination Operator</label>
                            <input type="text" id="laminationOperator" formControlName="laminationOperator"
                                class="form-control" />
                        </div>
                    </div>
                </div>
            </div>

            <!-- slitting -->
            <div *ngIf="tabActive === 'slitting'">
                <h5 class="text-left font-bold font-up danger-text">Slitting Details</h5>
                <div class="row mb-3">
                    <div class="col-md-6">
                        <div class="form-group">
                            <label for="slittingMachine">Slitting Machine</label>
                            <select class="form-select" formControlName="slittingMachine" >
                                <option value="" disabled selected>Select Slitting Machine</option>
                                <option value="Machine A">Machine A</option>
                                <option value="Machine B">Machine B</option>
                                <option value="Machine C">Machine C</option>
                            </select>
                        </div>
                    </div>
                    <div class="col-md-6">
                        <div class="form-group">
                            <label for="slittingSize">Slitting Size</label>
                            <input type="text" id="slittingSize" formControlName="slittingSize" class="form-control" />
                        </div>
                    </div>
                </div>
            </div>

            <!-- cutting -->
            <div *ngIf="tabActive === 'cutting'">
                <h5 class="text-left font-bold font-up danger-text mt-3">Cutting Details</h5>
                <div class="row mb-3">
                    <div class="col-md-6">
                        <div class="form-group">
                            <label for="cuttingMachine">Cutting Machine</label>
                            <select class="form-select" formControlName="cuttingMachine" >
                                <option value="" disabled selected>Select Cutting Machine</option>
                                <option value="Machine A">Machine A</option>
                                <option value="Machine B">Machine B</option>
                                <option value="Machine C">Machine C</option>
                            </select>
                        </div>
                    </div>
                    <div class="col-md-6">
                        <div class="form-group">
                            <label for="cuttingParameters">Cutting Parameters</label>
                            <input type="text" id="cuttingParameters" formControlName="cuttingParameters"
                                class="form-control" />
                        </div>
                    </div>
                </div>
            </div>





            <!-- Submit Button -->
            <!-- <button type="submit" class="btn btn-primary mt-3" (click)="addPrintingDetail()"
                [disabled]="!productionForm.valid">Submit</button> -->

                <!-- for not allowing blank entries(production and inking) -->
                <!-- <button type="submit" class="btn btn-primary mt-3" [disabled]="!isSubmitEnabled()">Submit</button> -->
                 <!-- after merging -->
                 <button type="submit" class="btn btn-primary mt-3" 
                 (click)="addPrintingDetail()" 
                 [disabled]="!(productionForm.valid && isSubmitEnabled())">Submit</button>


            <!-- without validation -->
            <!-- <button type="submit" class="btn btn-primary mt-3" (click)="addPrintingDetail()" >Submit</button> -->
        </form>
    </div>
</div>

<!-- <div class="card mb-4">
    <div class="card-body">

        <div class="row">

            <div class="col-md-12">
                <div class="row">
                    <div class="col-md-12">

                    </div>

                </div>
            </div>

        </div>

        <div class="table-responsive">
            <table class="table table-bordered red-border text-center">
                <thead>
                    <tr>
                        <th>Ref no</th>
                        <th>PO No.</th>

                        <th>Client Name</th>
                        <th>Job Name</th>
                        <th>Order Quantity</th>

                        <th>Shift</th>

                        <th>Machine</th>
                        <th>Operator</th>
                        <th>OperatingTime</th>

                        <th>McSpeed</th>
                        <th>InkGsm</th>






                        <th *ngIf="isAddProduction">Specification</th>
                        <th *ngIf="isAddProduction">Roll No.</th>
                        <th *ngIf="isAddProduction">Weight</th>


                        <th *ngIf="isAddProduction">Avl Time</th>

                        <th *ngIf="isInking">Ink Color</th>
                        <th *ngIf="isInking">Ink Type</th>
                        <th *ngIf="isInking">Ink Name</th>






                    </tr>
                </thead>
                <tbody>
                    <tr *ngFor="let entry of materialMixEntries; let i = index">
                        <td>{{ entry.matArray[0].refNo}}</td>
                        <td>{{ entry.matArray[0].poNo}}</td>


                        <td>{{ entry.matArray[0].clientName}}</td>
                        <td>{{ entry.matArray[0].jobName}}</td>
                        <td>{{ entry.matArray[0].orderKgs }}</td>

                        <td>{{ entry.matArray[0].shift }}</td>

                        <td>{{ entry.matArray[0].machine }}</td>
                        <td>{{ entry.matArray[0].operator }}</td>
                        <td>{{ entry.matArray[0].operatingTime }}</td>

                        <td>{{ entry.matArray[0].mcSpeed }}</td>
                        <td>{{ entry.matArray[0].inkGsm }}</td>





                        <td *ngIf="isAddProduction">{{ entry.matArray[0].matSpecifications }}</td>
                        <td *ngIf="isAddProduction">{{ entry.matArray[0].matRollNo }}</td>
                        <td *ngIf="isAddProduction">{{ entry.matArray[0].prodWeight }}</td>


                        <td *ngIf="isAddProduction">{{ entry.matArray[0].availTime }}</td>

                        <td *ngIf="isInking">{{ entry.matArray[0].inkColor }}</td>
                        <td *ngIf="isInking">{{ entry.matArray[0].inkType }}</td>
                        <td *ngIf="isInking">{{ entry.matArray[0].inkName }}</td>






                    </tr>

                </tbody>
            </table>
        </div>



    </div>
</div> -->